import { LoadingButton } from '@mui/lab';
import * as Yup from 'yup';
import { immediateToast } from 'utils/toast';
import { useChargeWalletMutation } from '../../../../app/store';
import { handleServerErrors, moneyFormatInt } from '../../../../utils/utils';
import Dialog from 'components/dialog/dialog';
import { Field, Formik } from 'formik';
import { PriceField } from '../../../../components/formik/price-field/price-field';
import { Box } from '@mui/material';

const ChargeWalletSchema = Yup.object().shape({
    amount: Yup.number()
        .required('مقدار افزایش اعتبار الزامی است')
        .typeError('مقدار وارد شده باید یک عدد باشد')
        .integer('مقدار وارد شده باید یک عدد باشد')
        .min(5000, 'مقدار افزایش اعتبار باید 5,000 ریال باشد')
        .max(1000000, ' مقدار افزایش نمی‌تواند بیشتر از 1,000,000 ریال باشد')
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value,
        ),
});

const ChargeWalletModal = ({
    modalOpen,
    onClose,
    id,
    title,
}: any): JSX.Element => {
    const [chargeWallet, { isLoading }] = useChargeWalletMutation();

    const handleIncreaseCredit = ({ amount }: any) => {
        chargeWallet({
            amount: moneyFormatInt(amount),
            id,
        })
            .unwrap()
            .then((payLink: { pay_url: string }) => {
                immediateToast('success', {
                    message: 'در حال انتقال به درگاه پرداخت',
                    timeout: 5000,
                });

                window.location.replace(payLink.pay_url);
            })
            .catch((err) => {
                handleServerErrors(err);
            });
    };

    return (
        <Dialog
            label={'افزایش اعتبار ' + title}
            open={modalOpen}
            onClose={onClose}
            icon={<i className="fa-light fa-plus" />}
            type="success">
            <Formik
                initialValues={{ amount: undefined }}
                onSubmit={handleIncreaseCredit}
                validationSchema={ChargeWalletSchema}
                validateOnChange={false}
                validateOnBlur={false}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Field
                            component={PriceField}
                            liveValidation={false}
                            fullWidth
                            name="amount"
                            maxLength={10}
                            icon={
                                <i className="fa-light fa-money-bill-alt"></i>
                            }
                            secondIcon={
                                <span style={{ marginRight: '-5px' }}>
                                    ريال
                                </span>
                            }
                            label="مبلغ افزایش اعتبار"
                        />
                        <LoadingButton
                            fullWidth
                            variant="contained"
                            type="submit"
                            sx={{ mt: 4 }}
                            loading={isLoading}>
                            افزایش اعتبار
                        </LoadingButton>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
};

export { ChargeWalletModal };
